import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const PERIODS = [["month", "Mois"], ["quarter", "Trimestre"], ["year", "Année"], ["all", "Origine"]];
const eur = (n) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

function Kpi({ id, label, value, hint }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-3" data-testid={`mk-stat-${id}`} title={hint}>
      <div className="text-[11px] font-bold uppercase tracking-wide text-slate-500">{label}</div>
      <div className="font-display text-2xl font-extrabold text-slate-900" data-testid={`mk-stat-${id}-value`}>{value}</div>
    </div>
  );
}

export function MarketplaceStats() {
  const [period, setPeriod] = useState("year");
  const [s, setS] = useState(null);
  useEffect(() => { api.get(`/marketplace/stats?period=${period}`).then((r) => setS(r.data)).catch(() => toast.error("Indicateurs indisponibles")); }, [period]);
  if (!s) return <div className="text-sm text-slate-500 p-4" data-testid="mk-stats-loading">Chargement des indicateurs…</div>;
  const L = s.leads, F = s.finance, M = s.methodology;
  return (
    <div className="space-y-4" data-testid="mk-stats">
      <div className="card-base p-4 flex flex-wrap items-center gap-3">
        <div className="flex gap-2">{PERIODS.map(([k, l]) => <button key={k} onClick={() => setPeriod(k)} className={`px-3 py-1 rounded-full text-xs font-bold ${period === k ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-700"}`} data-testid={`mk-stats-period-${k}`}>{l}</button>)}</div>
        <div className="text-xs text-slate-500" data-testid="mk-stats-period-label">Période : <b>{s.period.label}</b> ({s.period.from} → {s.period.to})</div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Kpi id="generes" label="Leads générés" value={L.generes} hint={M.generes} />
        <Kpi id="conserves" label="Leads conservés" value={L.conserves} hint={M.conserves} />
        <Kpi id="publies" label="Leads publiés" value={L.publies} hint={M.publies} />
        <Kpi id="reserves" label="Leads réservés" value={L.reserves} hint={M.reserves} />
        <Kpi id="attribues" label="Leads attribués" value={L.attribues} hint={M.attribues} />
        <Kpi id="mandats" label="Transformés en mandats" value={L.mandats} hint={M.mandats} />
        <Kpi id="finances" label="Dossiers financés" value={L.finances} hint={M.finances} />
        <Kpi id="delai" label="Délai moyen attribution → mandat" value={s.delai_moyen_transformation_jours == null ? "n.c." : `${s.delai_moyen_transformation_jours} j`} hint={`${M.delai} Échantillon : ${s.delai_sample}.`} />
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        <div className="card-base p-4 space-y-2" data-testid="mk-stats-honoraires">
          <h3 className="font-display text-base font-extrabold text-slate-900">A. Honoraires des dossiers distribués</h3>
          <Row label="CA prévisionnel" v={eur(F.honoraires.previsionnel)} id="hono-prev" />
          <Row label="CA réalisé (statut signé)" v={eur(F.honoraires.realise)} id="hono-real" />
          <Row label="CA encaissé (date d'encaissement saisie)" v={eur(F.honoraires.encaisse)} id="hono-enc" />
          <p className="text-[11px] text-slate-500">{M.honoraires}</p>
        </div>
        <div className="card-base p-4 space-y-2" data-testid="mk-stats-part">
          <h3 className="font-display text-base font-extrabold text-slate-900">B. Part Marketplace théorique ({s.split_pct} %)</h3>
          <Row label="Part prévisionnelle" v={eur(F.part_marketplace.previsionnel)} id="part-prev" />
          <Row label="Part acquise (statut signé)" v={eur(F.part_marketplace.acquise)} id="part-acq" />
          <Row label="Part encaissée" v={eur(F.part_marketplace.encaissee)} id="part-enc" />
          <p className="text-[11px] text-amber-700">{M.part_marketplace}</p>
        </div>
      </div>
      <div className="text-[11px] text-slate-500 card-base p-3" data-testid="mk-stats-scope"><b>Périmètre</b> : {s.scope} · Retours : {L.retournes}. Un acte signé n'est jamais assimilé à un encaissement ; aucune commission bancaire ni Pretto n'est ajoutée.</div>
    </div>
  );
}

function Row({ label, v, id }) {
  return <div className="flex justify-between text-sm" data-testid={`mk-stat-${id}`}><span className="text-slate-600">{label}</span><b className="text-slate-900">{v}</b></div>;
}
